/**
 * History component (timeline and carousel)
 */

var component_history = function(args) {

  // setup args
  var history_block  = args.history_block;
  var timeline       = history_block.querySelector('.polar-timeline');
  var timeline_items = history_block.querySelectorAll('.polar-timeline__item');
  var timeline_points  = history_block.querySelectorAll('.polar-timeline__item__point');

  // SweetScroll scroller
  var scroller       = SweetScroll.create({horizontal: true, duration: 500}, timeline);

  // validate
  if (!history_block) {
    console.log('Invalid history block');
    return;
  }

  /**
   * Set timeline height
   */
  function setTimelineHeight() {
    let itemHeights = [];
    history_block.querySelectorAll('.polar-timeline__item__text-wrap').forEach(element => {
      itemHeights.push(parseInt(element.offsetHeight));
    });
    // set height based on highest timeline element
    timeline.style.height = `calc(${Math.max(...itemHeights)}px + 5.5rem)`;
  }

  /**
   * Timeline functionality
   *
   * @param {Element} slider Glide.js instance
   * @param {Element} scroller SweetScroll instance
   */
  function timelineNavigation(slider, scroller) {
    slider.on('run.after', () => {
      scrollTimeline(slider, scroller);
      setActivePoint(timeline_points);
    })

    // set active point
    setActivePoint(timeline_points);

    // add glide.js attributes to timeline points
    for (var i = 0; i < timeline_points.length; i++) {
      timeline_points[i].setAttribute('data-glide-dir', `=${i}`);
      handlePointClick(timeline_points[i]);
    }

    /**
     * Handle click on timeline point
     *
     * @param {Element} point
     */
    function handlePointClick(point) {
      point.addEventListener('click', (event) => {
        slider.go(event.target.dataset.glideDir);
        slider.on('run.after', () => {
          setActivePoint(timeline_points);
        })
      })
    }

    /**
     * Set active timeline point
     *
     * @param {NodeList} points timeline points
     */
    function setActivePoint(points) {
      // remove active class from points (reset)
      points.forEach((point) => {point.classList.remove('polar-timeline__item__point--active')});

      // set active point
      points[slider.index].classList.add('polar-timeline__item__point--active');
    }

    /**
     * Scrolls timeline to correct point
     *
     * @param {Element} slider Glide.js slider
     * @param {Element} scroller SweetScroll instance
     */
    function scrollTimeline(slider, scroller) {
      scroller.toElement(timeline_items[slider.index]);
    }
  }

  function carousel(carousel) {
    if (carousel) {
      try {
        let slider = new Glide(carousel, {
          type: 'carousel',
          animationDuration: 500,
          autoplay: false,
          hoverPause: true,
          perView: 1,
        });

        // mount slider
        slider.mount();

        timelineNavigation(slider, scroller);

        } catch (e) {
          console.log(e);
       }
    }
  }

  /**
   * Init
   */
  function init() {
    setTimelineHeight();
    carousel(history_block.querySelector('.polar-history__slider'));
  }

  init();

  // make the call chainable
  return this;

};

